<template lang='pug'>
  div
    v-container.pa-3(fluid, grid-list-xl)
      v-layout(row, wrap)
        template(v-for='(component, index) in json.components')
          u-label(
            v-if="component.type === 'label'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues")
          v-flex(:class="component.style || 'xs12'", v-if="component.type === 'info' && formValues[component.reference]", :key='component.key+"-"+index')
            .body-1.font-regular-thin.font-italic {{ formValues[`${jsonID}.${component.key}`] || t(`${jsonID}.${component.key}`, component.label) }}
          v-flex(v-if="component.type === 'divider'", :key='component.key+"-"+index' xs12)
            v-divider
          u-checkbox(
            v-if="component.type === 'checkbox'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component")
          v-checkbox(
            v-if="component.type === 'v-checkbox'"
            :label="component.label"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component")
          u-radio(
            v-if="component.type === 'radio'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component")
          u-select(
            v-if="component.type === 'select'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues")
          u-select-image(
            v-if="component.type === 'selectimage'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues")
          u-text-field(
            v-if="component.type === 'textfield'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues"
            :json="json")
          u-upload(
            v-if="component.type === 'upload'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component")
          u-date(
            v-if="component.type === 'datepicker'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues")
          u-text-area(
            v-if="component.type === 'textarea'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component")
          u-rich-text-editor(
            v-if="component.type === 'richtexteditor'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :fill-template="json.fillTemplate"
            :suggest-conclusion="json.suggestConclusion"
            :resultForm.sync="formValues"
          )
          u-table(
            v-if="component.type === 'table'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues")
          u-tabs(
            v-if="component.type === 'tab'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :form-id="`${jsonID}.${component.key}`"
            :resultForm.sync="formValues")
          u-chart-line(
            v-if="component.type === 'chartline'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :chart-data="formValues[`${jsonID}.${component.key}`]"
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm="formValues")
          u-evolution-chart(
            v-if="component.type === 'evolutionchart' && formValues[`${jsonID}.${component.key}`] && formValues[`${jsonID}.${component.key}`].result && formValues[`${jsonID}.${component.key}`].result.length > 0"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :component="component"
            :values="formValues"
            :id='`${jsonID}.${component.key}`')
          u-g-chart(
            v-if="component.type === 'gChart'"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :result="formValues[`${jsonID}.${component.key}`]"
            :component="component"
            :values="formValues"
            :id='`${jsonID}.${component.key}`')
          u-image(
            v-if="component.type === 'image'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            v-model="formValues[`${jsonID}.${component.key}`]"
            :component="component"
            :resultForm.sync="formValues"
            :id='`${jsonID}.${component.key}`')
          u-zscore(
            v-if="component.type === 'zscore'"
            v-show="checkDeprecated(component)"
            :key='component.key+"-"+index'
            :id='`${jsonID}.${component.key}`'
            :component="component"
            :resultForm.sync="formValues"
            :chart-data="formValues[`${jsonID}.${component.key}`]")
</template>

<script>
import UCheckbox from './inputs/Checkbox'
import URadio from './inputs/Radio'
import USelect from './inputs/Select'
import USelectImage from './inputs/SelectImage'
import UTextField from './inputs/TextField'
import UUpload from './inputs/Upload'
import UDate from './inputs/Date'
import UTextArea from './inputs/TextArea'
import URichTextEditor from './inputs/RichTextEditor'
import UChartLine from './inputs/ChartLine'
import UTable from './inputs/Table'
import UTabs from './layout/Tabs'
import UEvolutionChart from '@/components/charts/EvolutionChart'
import UGChart from '@/components/charts/GChart'
import utilObject from '@/utils/object'
import UImage from './inputs/Image'
import ULabel from './inputs/Label'
import UZscore from './inputs/Zscore'

export default {
  name: 'u-form',

  components: {
    UCheckbox,
    URadio,
    USelect,
    USelectImage,
    UTextField,
    UUpload,
    UDate,
    UTextArea,
    URichTextEditor,
    UTable,
    UTabs,
    UChartLine,
    UEvolutionChart,
    UGChart,
    UImage,
    ULabel,
    UZscore
  },

  props: {
    id: {
      type: String
    },
    value: {
      type: Object
    },
    json: {
      type: Object,
      required: true
    },
    resultJSON: {
      type: Boolean,
      default: false
    },
    formKey: {
      type: String,
      required: false
    }
  },

  computed: {
    jsonID () {
      if (this.formKey) return this.formKey
      let id = `${this.id ? this.id : ''}`
      id += `${this.json.key ? (id !== '' ? '.' : '') + this.json.key : ''}`
      return id
    }
  },

  watch: {
    value (val) {
      const result = this.resultJSON ? this.getMAP(val) : val
      this.formValues = result
    },
    formValues: {
      handler: function (val, oldVal) {
        this.updateFormValues(val)
      },
      deep: true
    }
  },

  mounted () {
    if (typeof this.value === 'object') {
      this.formValues = this.value
    }
  },

  data () {
    return {
      msg: 'teste',
      formValues: {}
    }
  },

  methods: {
    getJSON (values) {
      return utilObject.mapToObject(values)
    },
    checkDeprecated (component) {
      let index = this.jsonID + '.' + component.key
      if (component.deprecated) {
        if (this.formValues[index]) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    getMAP (obj, key, data = {}) {
      if (this.isObject(obj)) {
        var result = data
        for (var item in obj) {
          var newKey = (key ? key + '.' : '') + item
          var value = this.getMAP(obj[item], newKey, result)
          if (!this.isObject(value)) {
            result[newKey] = value
          }
        }
        return result
      } else if (Array.isArray(obj)) {
        var arr = []
        obj.forEach(item1 => {
          arr.push(this.getMAP(item1))
        })
        return arr
      }
      return obj
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    updateFormValues (val) {
      const newValue = this.resultJSON ? this.getMAP(this.value) : this.value
      if (JSON.stringify(newValue) === JSON.stringify(val)) return

      const result = this.resultJSON ? this.getJSON(val) : val
      this.$emit('input', result)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/form.vue